import { useSelector } from 'react-redux';
import { TFormTypes } from '../state/ui/forms';
import { TRootState } from '../store';

export const getStoredForm = (state: TRootState, type: TFormTypes) => {
    return state.ui.forms[type] || null;
};
export const useTaskStoredForm = () =>
    useSelector((state: TRootState) => getStoredForm(state, 'task'));
